// ABOUTME: SPEC-82 owner change (control_reveal) — the revealed control row starts OPEN whenever the dots appear and
// ABOUTME: ONLY a tap on the dots toggles it; no outside tap, no Escape, no timer (replaces spec D-15 / OQ-2).

import { useCallback, useEffect, useLayoutEffect, useState } from 'react';
import { setBottomChrome } from '../../../uiExperiment/bottomChromeStore';
import { REVEAL } from './voiceDockTokens';

/**
 * @param {object} p
 * @param {boolean} p.enabled the `control_reveal` toggle AND the dots are what is on screen (not the pre-tap CTA, not the film)
 * @param {boolean} [p.reducedMotion] publishes tweenMs 0 so the lifted consumers move instantly too
 * @returns {{open:boolean, toggle:Function}}
 */
export default function useControlReveal({ enabled, reducedMotion = false }) {
  // Remembers only the guest's own "close it": the default while the dots are shown is open (owner ruling), so the
  // state is `closed`, not `open` — there is no first-frame moment where the row is waiting for an effect to open it.
  const [closed, setClosed] = useState(false);
  const open = enabled && !closed;
  const toggle = useCallback(() => setClosed((c) => !c), []);

  // Publish for the bottom band. A LAYOUT effect: the mobile tag row, card and sheet must be lifted in the very commit that
  // mounts the open row (a passive effect would paint one frame of tags underneath the row, then jump). tweenMs 0 keeps
  // flag-off consumers free of any `transition`. Cleared on unmount so a torn-down dock can never leave the band lifted.
  useLayoutEffect(() => {
    setBottomChrome({ controlsOpen: open, tweenMs: enabled && !reducedMotion ? REVEAL.ms : 0 });
  }, [open, enabled, reducedMotion]);
  useEffect(() => () => setBottomChrome({ controlsOpen: false, tweenMs: 0 }), []);

  return { open, toggle };
}
